import { useEffect } from 'react';
import { withLatestFrom } from 'rxjs';
import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { WidgetPayload } from '@client/widgets/widget.types';
import { useCreateTemplate } from './create-template.hook';
import { useWidget } from '@client/widgets/widget.hook';
import { useDraftState } from '@client/state/draft-form-state.hook';
import { useWindow } from '@client/window/window.hook';
import { useTradingWorkspaceDestroy$ } from '@client/features/trading-workspace/trading-workspace-scope.context';
import { takeUntil } from 'rxjs';

export const useCreateTemplateForm = () => {
  const { openWidget$ } = useWidget();
  const { openWindow } = useWindow();
  const { state$ } = useDraftState();
  const workspaceDestroy$ = useTradingWorkspaceDestroy$();

  const { onSubmit } = useCreateTemplate();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(
        filterWidgetEvent<WidgetPayload, 'SaveTradingTemplateForm'>(
          'SaveTradingTemplateForm'
        ),
        withLatestFrom(state$),
        takeUntil(workspaceDestroy$)
      )
      .subscribe(([{ templateType, timeframeIndex }, draftState]) => {
        if (!draftState) return console.error('No draft state found');
        openWindow({
          type: 'SaveTradingTemplateForm',
          sizePreset: 'form',
          componentProps: {
            onSubmit: onSubmit(draftState, templateType, timeframeIndex)
          }
        });
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [onSubmit, openWidget$, openWindow, state$, workspaceDestroy$]);
};
